import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AppConfigService } from 'src/app/services/app-config.service';
import { IAppConfig } from '../interfaces/app-config';
import { LFDocument } from '../interfaces/document';
import { GridDataResponse, NestedGridRequest } from '../interfaces/grid-data-response';
import { assertTrustedUrl } from '../functions/validate-url';

@Injectable()
export class GridService {
  config: IAppConfig;

  constructor(
    private http: HttpClient,
    private appConfigService: AppConfigService
  ) {
    this.config = this.appConfigService.getConfig();
  }

  public query(gridApiRoute: string, state: any, selectColumns: string[], location: string, Studentsk: string, roleId: number, roleName: string): Observable<GridDataResponse> {      
    if (gridApiRoute === 'EventLog') {
      if (state?.filter?.filters?.length >= 1) {
        const lastFilter = state.filter.filters[state.filter.filters.length - 1];
        const initialGridState: any = {
          skip: 0,
          take: 10,
          sort: [
            {
              field: state?.sort[0] === undefined ? 'dateTimeOccurred' : state?.sort[0]?.field,
              dir: state?.sort[0]?.dir === undefined ? 'desc' : state?.sort[0]?.dir
            }
          ],
          group: [],
          filter: {
            field: lastFilter.filters[0]?.field
            ,
            operator: lastFilter.filters[0]?.operator,
            value: lastFilter.filters[0]?.value,
            logic: lastFilter.logic,
            filters: [{
              field: state?.filter?.filters[0]?.filters[0]?.field
              ,
              operator: state?.filter?.filters[0]?.filters[0]?.operator,
              value: state?.filter?.filters[0]?.filters[0]?.value,
              logic: state?.filter?.logic,
              filters: []
            }
            ]
          }

        };
        return this.http
          .post<GridDataResponse>(`${this.config.studentApiUrl}/` + gridApiRoute + '/kendogrid',
            { distinctFields: selectColumns, dataSourceRequest: initialGridState, location: location, Studentsk: Studentsk, roleId: roleId, roleName: roleName })
          .pipe(
            catchError(this.handleError)
          );
      } else {
        return this.http
          .post<GridDataResponse>(`${this.config.studentApiUrl}/` + gridApiRoute + '/kendogrid',
            { distinctFields: selectColumns, dataSourceRequest: state, location: location, Studentsk: Studentsk, roleId: roleId, roleName: roleName })
          .pipe(
            catchError(this.handleError)
          );
      }
    } else if (gridApiRoute === 'eitransition') {
      if (state?.filter?.filters){
        const studentNameFilter = state.filter.filters.find(outerFilter => outerFilter.filters.find(innerFilter => innerFilter.field === 'studentName'));
        if (studentNameFilter) {
          studentNameFilter.logic = 'or';
          studentNameFilter.filters = [...studentNameFilter.filters, {field : 'eId', operator: studentNameFilter.filters[0].operator, value: studentNameFilter.filters[0].value}]
        }
        state.filter.filters = state.filter.filters.filter(outerFilter => !outerFilter.filters.every(innerFilter => innerFilter.field === 'eId'));
        state.sort = [];
      }
      return this.http
        .post<GridDataResponse>(`${this.config.apiUrl}/` + gridApiRoute + '/kendogrid',
          { distinctFields: selectColumns, dataSourceRequest: state, location: location, roleId: roleId })
        .pipe(
          catchError(this.handleError)
        );
    } else {
      return this.http
      .post<GridDataResponse>(`${this.config.apiUrl}/` + gridApiRoute + '/kendogrid',
        { distinctFields: selectColumns, dataSourceRequest: state, location: location, roleId: roleId })
      .pipe(
        catchError(this.handleError)
      );
    }

  }
  
  public nestedGridQuery(gridApiRoute: string, data: NestedGridRequest): Observable<GridDataResponse> {
    const url = assertTrustedUrl(
      `${this.config.apiUrl}/${encodeURIComponent(gridApiRoute)}/grid`,
      this.config.apiUrl
    );
    return this.http
      .post<GridDataResponse>(url, data
      )
      .pipe(catchError(this.handleError)
      );
  }

  // TODO this should be moved into it's own class, this grid is getting way too clunky
  public nestedEIGridQuery(studentSk: string): Observable<LFDocument[]> {
    const url = assertTrustedUrl(
      `${this.config.apiUrl}/EITransition/ChildDocuments/${encodeURIComponent(studentSk)}`,
      this.config.apiUrl
    );
    return this.http
      .get<LFDocument[]>(url
      )
      .pipe(catchError(this.handleError)
      );
  }

  // Error handling
  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    // window.alert(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }
}
